import {
    RequestConfigFunction,
    SelectorConfig,
} from 'app/types/request.types'
import {
    Country,
} from 'app/Apps/ContactManagement/Countries/Countries.types'

type CountryRequests = {
    domainName: string,
    get: RequestConfigFunction<{id: number}>,
    getAll: RequestConfigFunction<Record<string, any> | undefined>,
}

const countryRequests: CountryRequests = {
    domainName: 'Country',
    get: ({
        id,
    }) => {
        return {
            url: `country/${id}`,
            method: 'GET',
        }
    },
    getAll: (data) => {
        return {
            url: 'country/filter-request/selector',
            method: 'POST',
            data,
        }
    },
}

export const countrySelectionConfig: SelectorConfig<Country[]> = {
    url: countryRequests.getAll().url,
    convertion: (countries: Country[]) => {
        return countries.map(({
            countryName, id,
        }) => {
            return {
                id,
                label: countryName,
                value: id,
                countryName,
            }
        })
    },
}

export default countryRequests
